<template>
	<img class="zidingyi_tu" :src="shu.shu.tu" :style="yangshi" v-if="shu.shu"></img>
</template>

<script>
	export default {
		name: 'tu',
		data() {
			return {
				yangshi: ''
			}
		},
		props: {
			shu: {
				type: Object,			
			}
		},
		mounted() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', {					
					tu: 'https://limitao.myuan.cn/gongyong/shangchuan/tu/12/2019/11/r7Rc8mBC1BeuLcerUEUY7u22M7p12R.png',
					url:''
				})
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}			
		},
		watch: {		
			'shu.yangshi.width':function(){
				this.Ys();
			},
			'shu.yangshi.height':function(){
				this.Ys();
			},
			'shu.yangshi.text_align':function(){
				this.Ys();
			},
			'shu.yangshi.margin':function(){
				this.Ys();
			},
			'shu.yangshi.padding':function(){
				this.Ys();
			},
			'shu.yangshi.border_radius':function(){
				this.Ys();
			},
		},
		methods:{
			Ys(){
				this.yangshi = "";
				var px='';
				if (this.shu.yangshi.width) {
					px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
					this.yangshi += "width:" +px+ ";";
				}
				if (this.shu.yangshi.height) {				
					px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
					this.yangshi += "height:" + px+ ";";
				}
				if (this.shu.yangshi.text_align) {				
					this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
				}	
				if (this.shu.yangshi.margin) {
					px=(this.shu.yangshi.margin>0)?(this.shu.yangshi.margin+'px'):this.shu.yangshi.margin;		
					this.yangshi += "margin:" + px+ ";";
				}
				if (this.shu.yangshi.padding) {
					px=(this.shu.yangshi.padding>0)?(this.shu.yangshi.padding+'px'):this.shu.yangshi.padding;		
					this.yangshi += "padding:" + px+ ";";
				}
				if (this.shu.yangshi.border_radius) {
					px=(this.shu.yangshi.border_radius>0)?(this.shu.yangshi.border_radius+'px'):this.shu.yangshi.border_radius;		
					this.yangshi += "border-radius:" + px+ ";";
				}
				console.log(this.yangshi)
			}
		}


	}
</script>
<style>
	ss{
		text-align: ;
	}
</style>